//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SelectCardType',
  data: function data() {
    return {
      selectCardType: '',
      cardTypeOptions: []
    };
  },
  props: {
    initCardType: [Number, String],
    cardTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    initCardType: {
      handler: function handler(val) {
        this.selectCardType = val || '';
      },
      immediate: true,
      deep: true
    },
    cardTypeList: {
      handler: function handler(val) {
        console.log('接收到发卡类型列表:', val);
        this.cardTypeOptions = val || [];
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    // 如果有初始值，设置选中项
    if (this.initCardType) {
      this.selectCardType = this.initCardType;
    }
  },
  methods: {
    changeSelect: function changeSelect(e) {
      console.log('选择发卡类型:', e);
      this.$emit('selectCardType', e);
      this.$emit('change', e);
    }
  }
};